module.exports = __webpack_public_path__ + "img/省部级科技进步奖.eb31f7a5.jpg";